export default class SystemMetricsService {
  constructor($http) {
    'ngInject';

    Object.assign(this, {
      $http
    });
  }

  getReport(params) {
    return this.$http.get('/api/report/data_m_y_admin', {
      params: {
        ...params
      }
    }).then(r => r.data);
  }
}



// WEBPACK FOOTER //
// ./components/app/reports/system-metrics/system-metrics.service.js